/**
 * Enum of BIGStudio to express softawre section as enum.
 * It include also not implement App section
 */
export enum PageSection {
  ALL = -1,
  UNKNOWN = 0,

  SUPERVISION_CUSTOM_INTERFACE = 101,
  SUPERVISION_COMPONETNS = 102,
  SUPERVISION_CUSTOM_INTERFACE_LIST = 110,

  ACCESSCONTROL_CUSTOMER_STAFF = 201,
  ACCESSCONTROL_RESERVATION,
  ACCESSCONTROL_CARDS,
  ACCESSCONTROL_TIMESLOT,
  ACCESSCONTROL_ACTION,

  GROUPADDRESS_ = 301,

  SCENARIONSCHEDULE_SCENARIOS = 401,
  SCENARIONSCHEDULE_SCHEDULES,

  LOGICSALARMS_LOGICS = 501,
  LOGICSALARMS_ALARM,
  LOGICSALARMS_CUSTOM_LOGICS,
  LOGICSALARMS_MACRO,
  LOGICSALARMS_CUSTOMMACRO,
  LOGICSALARMS_LOGICSGROUP,

  CONFIGURATION_GATEWAYS = 601,
  CONFIGURATION_TOPOLOGY,
  CONFIGURATION_CALENDARS,
  CONFIGURATION_DATETIMEPLANTCODE,
  CONFIGURATION_CARDPROGRAMMERS,
  CONFIGURATION_ABB_MAC2,
  CONFIGURATION_DEVICES,
  CONFIGURATION_UNIT_OF_MEASURE,
  CONFIGURATION_TREE_NODES,
  CONFIGURATION_USER,
  CONFIGURATION_USERGROUP,
  CONFIGURATION_WORKSTATION,
  CONFIGURATION_REPORT,
  CONFIGURATION_CHARTS,
  CONFIGURATION_NOTIIFICATION,
  CONFIGURATION_DATAPROCESS,
  CONFIGURATION_EMERGENCY_LAMPS,
  CONFIGURATION_MAINTANANCE,
  CONFIGURATION_MEDIA,
  CONFIGURATION_PAYMENT,
  CONFIGURATION_LOADCONTROL,
  CONFIGURATION_REPORT_HTML,
  CONFIGURATION_REPORT_PAYMENT_GENERATION,

  SETTINGS_SOFTWARE = 701,
  SETTINGS_SERVER,

  HISTORY_ACCESS = 801,
  HISTORY_LOGICS,
  HISTORY_MAINTANANCE,
  HISTORY_PAYMENT_REPORT,
  HISTORY_NAVIGATE_TO_DEVICE_VALID_LIST = 850,

  COMUNICATIONS_ = 901,

  PMS_ = 902,

  ACCESSES_ROOM = 1001,
  ACCESSES_SUITE = 1002,
  ACCESSES_JUNIOR_SUITE = 1003,
  ACCESSES_SINGLE_ROOM = 1004,
  ACCESSES_DOUBLE_ROOM = 1005,
  ACCESSES_TRIPLE_ROOM = 1006,
  ACCESSES_FAMILY_ROOM = 1007,
  ACCESSES_DORMITORY = 1008,
  ACCESSES_COMMON = 1009,
  ACCESSES_ELEVATOR_FLOOR = 1010,
  ACCESSES_CABINETS = 1011,
  ACCESSES_SKI_DEPOSITIS = 1012,
  ACCESSES_EXTERNAL_ACCESS = 1013,

  QR_CODES = 1101,

  WEEKLY_PLANNING = 1201,

  REPORT_PAYMENT_GENERATION = 1301,

  SCAN_AND_GO = 1401,
}
